import { SignalRContext } from "app/AppContext";
import { LANDING_PAGE_ROUTE } from "config/route-consts";
import Login from "pages/Authentication/Login/Login";
import { PrivateRoute } from "pages/Authentication/PrivateRoute";
import ForbidentView from "pages/ForbidentView/ForbidentView";
import React, { Fragment } from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";
import signalRService from "services/common-services/signalr-service";
import LandingPageView, {
  DecodeToken,
} from "views/LandingPageView/NewLandingPage";
import WebFont from "webfontloader";
import "./i18n/i18n";
import * as serviceWorker from "./serviceWorker";
import store from "./store";
import * as Cookie from "js-cookie";
import jwtDecode from "jwt-decode";
import moment from "moment";

WebFont.load({
  google: {
    families: ["Inter"],
  },
});

const app = (
  <Fragment>
    <Provider store={store}>
      <SignalRContext.Provider value={signalRService}>
        <React.Suspense fallback={null}>
          <BrowserRouter basename="/">
            <Switch>
              <Route
                exact
                path={`/login`}
                render={() => {
                  if (
                    Cookie.get("Token") &&
                    jwtDecode<DecodeToken>(Cookie.get("Token")).exp >
                      moment.now() / 1000
                  ) {
                    return <Redirect to={LANDING_PAGE_ROUTE} />;
                  } else {
                    return <Login />;
                  }
                }}
              />
              <Route exact path={`/403`} component={ForbidentView} />
              <Route
                exact
                path={LANDING_PAGE_ROUTE}
                component={LandingPageView}
              />
              <PrivateRoute path="/" />
            </Switch>
          </BrowserRouter>
        </React.Suspense>
      </SignalRContext.Provider>
    </Provider>
  </Fragment>
);

ReactDOM.render(app, document.getElementById("root"));
serviceWorker.unregister();
